import { ReactNode } from 'react';

import { LoginPage } from '#src/pages/login';
import { useUser } from '#src/providers/user-provider';

interface AuthGuardProps {
  children: ReactNode;
}

/**
 * Renders children (Layout + app routes) only when user email is set.
 * Otherwise shows the login page.
 */
export function AuthGuard({ children }: AuthGuardProps) {
  const { user } = useUser();
  const hasEmail = user.email.trim().length > 0;

  if (!hasEmail) {
    return <LoginPage />;
  }

  return <>{children}</>;
}
